import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { loadingCanton } from '../Optics/LoadingData/LoadingDataTerritory';
import { GET_3K_NODE_API_URL, NETSTAT_SWITCH_TOPO_URL, REAL_DOMAIN_SERVER_HTTPS } from '../Optics/OpticApiConfig';
import { loadNodeImagesFromServer } from '../Optics/FileResources/NodeFoto/ServiceUtilitiesNodeFoto';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const btnStyle = {
  background: "#474747",
  color: "#fff",
  border: "none",
  padding: "10px 15px",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "18px"
};
//#endregion 

const K3Nodes = (user) => {
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [showPhotos, setShowPhotos] = useState(false);
  const [selectedCanton, setSelectedCanton] = useState('');
   const [resultCantonOptic, setCantonOptic] = useState([]);
   const [filteredResult, setFilteredResult] = useState([]);
   const [error, setError] = useState(null);  
   const token = localStorage.getItem('token');
   const [canton, setCanton] = useState([]);
   const [isVisible, setIsVisible] = useState(false);
   const [regionFilter, setRegionFilter] = useState('');
const [photoIndex, setPhotoIndex] = useState(0);
const [uploadMessage, setUploadMessage] = useState('');
 
   useEffect(() => {
    //loadingCanton(setCanton); 
     setCanton(["Теремковский", "Святошинский"]);
   }, []); 

const openPhotos = async (item) => {
  await loadNodeImagesFromServer(
    item.sw3Hid,
    item.entrance,
    setSelectedPhotos,
    setUploadMessage
  );

  setPhotoIndex(0);
  setShowPhotos(true);
};
 
   // Загрузка данных
 const handleButtonClick = async () => {
   if (!selectedCanton) {
     setError('Пожалуйста, выберите округ.');
     return;
   }

 
 
   try {
     setError(null); 
     const response = await axios.get(GET_3K_NODE_API_URL, {
       headers: { Authorization: `Bearer ${token}` },
       params: { canton: selectedCanton }
     });
 
     setCantonOptic(response.data); // ✅ правильное имя
     setFilteredResult(response.data);
     setIsVisible(true);
   } catch (error) {
     console.error(error);
     setError('Произошла ошибка при загрузке данных.');
   }
 };
 
   // Фильтр по area
   const handleRegionFilterChange = (e) => {
     const value = e.target.value;
     setRegionFilter(value);
 
     if (!value) {
       setFilteredResult(resultCantonOptic);
       return;
     }
 
     const filtered = resultCantonOptic.filter(item => 
       item.region.toString().includes(value)
     );
     setFilteredResult(filtered);
   };

   const nextPhoto = () => {
  setPhotoIndex((prev) =>
    prev + 1 < selectedPhotos.length ? prev + 1 : 0
  );
};

const prevPhoto = () => {
  setPhotoIndex((prev) =>
    prev - 1 >= 0 ? prev - 1 : selectedPhotos.length - 1
  );
};
 
   return (
     <>
       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
         <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />
         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
           <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px", textShadow: '2px 2px 4px rgba(7, 7, 7, 1)' }}>
            3К
           </label>
           <Select
             className="selectSearchDrawer"
             options={canton.map(option => ({ value: option, label: option }))}
             isSearchable={true}
             styles={customStyles}
             placeholder="Округ"
             onChange={(selectedOption) => setSelectedCanton(selectedOption.value)} 
           />
           <button 
             className='buttonAutoTopology' 
             style={{ marginTop: "0px", padding: "10px" }}
             onClick={handleButtonClick} 
           >
             Загрузить
           </button>
         </div>
         <hr className="horizontalLineDrawer" style={{ marginTop: "0px" }} />
       </div>
    
       {isVisible && (
         <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
           
           {/* Фильтр по area */}
           <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
             <label style={{ marginLeft: '10px',color: "#c5c5c5", textShadow: '2px 2px 4px #131212ff'}}>Всего: <span style={{color: "orange"}}>{filteredResult.length}.</span></label>
            
             <input 
               type="number" 
               value={regionFilter} 
               onChange={handleRegionFilterChange} 
               placeholder="поиск по регионам" 
               className='textInputPoiskModal'
               style={{width: '150px',fontSize: '14px'}}
             />
            
           </div>
 
          <div className="scroll-container" 
             style={{
               flex: 1,
               maxWidth: "100%",
               maxHeight: "70vh",  
               overflowY: "auto",
               paddingBottom: "10px",
               display: "block" ,
               marginTop: '-20px'  
             }}>
           <table className="results-table" style={{ fontSize: '14px', tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th>Округ</th>
            <th>Регион</th>
            <th>Ветка</th>
            <th>Улица</th>
            <th>Дом</th>
            <th>IP</th>
            <th>ПАБ</th>
            <th>Домов</th>
            <th>Резерв</th>
            <th>Комментарий</th>
            <th>Фото</th>
            <th>Актуализация</th>
          </tr>
        </thead>

        <tbody>
          {filteredResult.length === 0 ? (
            <tr>
              <td colSpan="10" className="no-data">Нет данных для отображения</td>
            </tr>
          ) : (
            filteredResult.map((item, index) => {

              const hasPhotos = item.fotos && item.fotos.length > 0;

              const lastDate = hasPhotos
                ? new Date(
                    item.fotos
                      .sort((a, b) => new Date(b.createDate) - new Date(a.createDate))[0]
                      .createDate
                  ).toLocaleString()
                : null;

              return (
                <tr
                  key={index}
                  style={{
                    backgroundColor: hasPhotos ? "#3b473b" : "transparent"
                  }}
                >

                  <td>{item.canton}</td>

                  <td>{item.region}</td>

                  <td>{item.vetka}</td>

                  <td>
                    {item.sw3Street}
                  </td>

                  <td>{item.sw3House}</td>

                  <td>
                    {item.sw3Ip?.split(', ').map((ip, i) => (
                      <div key={i}>
                        <a
                          href={`${NETSTAT_SWITCH_TOPO_URL}ip=${ip}&action=up`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#92fd88b3" }}
                        >
                          {ip}
                        </a>
                      </div>
                    ))}
                  </td>

                  <td>{item.pab}</td>

                  <td>{item.rank4Switches}</td>

                 <td>
                    {item.reserves?.map((r, index) => (
                      <div key={index}>
                        {index + 1}) {r.isUps === 1
                          ?`⚡${ r.upsModel}`
                          : `⚡${r.upsModel} + 🔋${r.batteryModel}`}
                      </div>
                    ))}
                  </td>

                  <td>
                    {item.reserves?.map((r, index) => (
                      <div key={index}>
                        {index + 1}) {r.reserveNodeDescription}
                      </div>
                    ))}
                  </td>

                  {/* PHOTO COLUMN */}
                  <td>
                    {hasPhotos ? (
                      <button
                        onClick={() => openPhotos(item)}
                        style={{
                          background: "#2d6a2d",
                          color: "#fff",
                          border: "none",
                          padding: "5px 10px",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        📷 {item.fotos.length}
                      </button>
                    ) : (
                      <span style={{ color: "#ff4b4b", fontWeight: "bold" }}>
                        Нет
                      </span>
                    )}
                  </td>

                  {/* DATE COLUMN */}
                  <td>
                    {hasPhotos ? (
                      <span style={{ color: "#c5c5c5" }}>
                        {lastDate}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>

                </tr>
              );
            })
          )}
        </tbody>
      </table>
           </div>
           {showPhotos && (
        <div
          onClick={() => setShowPhotos(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            zIndex: 9999
          }}
        >

          {/* ОБЛАСТЬ СЛАЙДА*/}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}
          >

            {/* ЛЕВАЯ СТРЕЛКА */}
            <button
              onClick={() =>
                setPhotoIndex(prev =>
                  prev - 1 < 0 ? selectedPhotos.length - 1 : prev - 1
                )
              }
              style={btnStyle}
            >
              -
            </button>

            {/* КАРТИНКА */}
            <img
              src={selectedPhotos[photoIndex]?.url}
              alt=""
              style={{
                maxWidth: "80vw",
                maxHeight: "70vh",
                borderRadius: "10px"
              }}
            />

            {/* ПРАВАЯ СТРЕЛКА */}
            <button
              onClick={() =>
                setPhotoIndex(prev =>
                  prev + 1 >= selectedPhotos.length ? 0 : prev + 1
                )
              }
              style={btnStyle}
            >
              +
            </button>

          </div>

    {/* ИНДИКАТОР */}
    <div style={{ color: "#fff", marginTop: "10px" }}>
      {photoIndex + 1} / {selectedPhotos.length}
    </div>

  </div>
)}
         </div>
         
       )}
     </>
   );
 };
export default K3Nodes;
